import styled, { css, keyframes } from 'styled-components';
import Grid from 'styled-components-grid';
import breakpoint from 'styled-components-breakpoint';
import { StyledCoverMaxWidth } from '@components/Wrappers';

import {
  mx, my, mb, mt, px, p, py, pb, pl, pr, pt, m
} from 'styled-components-spacing';

import { fontCopyDefault } from '@styles/typography';
import { maxWidthWideStyle } from '@components/Wrappers/styles';
import { Video } from '@components';

import theme from '@theme';
import { RichTextStyle } from '@lib/styles/richtextEditiorStyles';
import {
  LocationIcon, DiagnoseIcon, NABHIcon, Bed, SpecialitiesIcon
} from '@images/svg/index';

const formWidth = '564px';

const {
  colors, gradients, borderRadius, shadows
} = theme;

const sectionSpacing = css`
  ${mb(4.5)}

  ${breakpoint('desktop')`
    ${mb(5.5)}
  `}
`;

const StyledCoverMaxWidth1 = styled.div`
  /* ${m(2)} */
  margin:0.5rem 0rem;
  ${breakpoint('mobile', 'tablet')`
    ${m(3)}
  `}
`;

export const StyledLocationIcon = styled(LocationIcon)`
  height: 12px;
  width: 20px;
  path {
    fill: ${props => (props.domain ? 'rgb(0, 81, 78)' : '#136c9d')};
  }
  ${breakpoint('mobile', 'desktop')`
   width:14px;
  `}
`;


export const StyledBlockHospital = styled.div`
  ${breakpoint('mobile', 'desktop')`
     margin:0px 3%;
     box-sizing: border-box;
  `}

`;

export const StyledCoverMaxWidthNoBottomMargin = styled.div`
  max-width: 1400px;
  margin-bottom: 20px;
  width: 100%;
  ${breakpoint('mobile', 'desktop')`
     width: 98%;
     margin-bottom: 35px;
  `}
`;

export const Heading = styled.h2`
  text-align: center;
  padding: 15px 0px 20px 0px;
  color:${props => (props.domain ? 'rgb(0, 81, 78)' : '#1a79a2')};
  font-size: 25px;
  font-weight: 700;
  line-height: 1.2;

  ${breakpoint('mobile', 'tablet')`
    padding:5px 0px;
    font-size:20px;
  `}
`;

export const StyledPackagesMobile = styled.div`
  /* margin-top: 20px; */
`;

export const StyledFlexCenter = styled(Grid)`
  display: flex;
  justify-content: center;
  margin-bottom: 2rem;
`;

export const StyledSeeMore = styled.a`
  font-size: 22px;
  color: #2485a6;
  cursor: pointer;
  margin: 0 auto;
  @media screen and (max-width: 400px) {
    font-size: 5vw;
  }
`;

export const StyledArrowWrapper = styled.div`
  width: calc(100% - 40px);
  position: relative;
  padding: 0 20px;
`;

const spin = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

export const Loader = styled.div`
  border: 16px solid #f3f3f3;
  border-radius: 50%;
  border-top: 16px solid #3498db;
  width: 80px;
  height: 80px;
  -webkit-animation: ${spin} 2s linear infinite; /* Safari */
  animation: ${spin} 2s linear infinite;
  margin: 0 auto;
  ${breakpoint('mobile', 'desktop')`
    width: 50px;
    height: 50px;
    border: 8px solid #f3f3f3;
    border-top: 6px solid #3498db;
  `}
`;

export const MainSubHealine = styled.h3`
  padding-top: 2.5rem;
  color:black;
  text-align: center;
  margin-top: 30px;
  font-size: 32px;
  line-height: 1.2;
  font-weight: 700;
  margin-bottom: 1rem;
  ${breakpoint('tablet', 'desktop')`
    font-size: 22px;
  `}
  ${breakpoint('mobile', 'tablet')`
    padding-top: 1.5rem;
    font-size: 18px;
    margin-bottom: 1.5rem;
  `}
`;

export const StyledFaciliyHeading = styled.div`
  color: #4a4949;
  font-size: 25px;
  font-weight: 700;
  text-align: center;
  padding: 25px 0px;
`;

export const StyledLocation = styled.div`
  font-size: 13px;
  padding: 10px 0px;
  ${breakpoint('mobile', 'desktop')`
    padding:15px 0px;
  `}
`;

export const StyledFacilityBlock = styled.div`
  ${breakpoint('tablet', 'desktop')`
    margin:0% 8%;
  `}
`;

export const StyledFacility = styled(Grid)`
  display: flex;
  justify-content: space-between;
  margin: 0.5rem 4rem;
  margin-bottom: 25px;
  justify-content: ${props => (props.cardno === 4 ? 'space-between' : 'space-evenly')};
  ${breakpoint('mobile', 'desktop')`
  margin:0px 10px;
  flex-direction: ${props => (props.cardno === 4 ? 'column' : 'row')};
  
  justify-content:space-evenly;
`}
`;

export const StyledBlock = styled.div`
  display: flex;
  flex: 0 0 50%;
  justify-content: space-around;
  ${breakpoint('mobile', 'desktop')`
  display:flex;
  flex-direction:row;
  justify-content:space-around;
`}
`;

export const StyledFacilityCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;
  background-color: #f8f9fa;
  padding: 20px 10px;
  border-radius: 15px;
  width: 20%;

  ${breakpoint('mobile', 'desktop')`
    height:110px;
    margin:6px 0px;
    width: ${props => (props.cardno === 4 ? '40%' : '20%')};
    padding:0px 5px;
  `}
`;

export const StyledFacilityInfo = styled.div`
  font-size: 15px;
  margin-top: 10px;
  padding-top: 10px;
  text-align: center;
  color:${props => (props.domain ? 'rgb(0,81,78)' : '#1a79a2')};
  ${breakpoint('mobile', 'desktop')`
    margin-top:0px;
    padding-top:0px;
    font-size:14px;
  `}
`;

export const StyledBedIcon = styled(Bed)`
  height: 50px;
  width: 120px;
  path {
    fill: ${props => (props.domain ? 'rgb(0, 81, 78)' : '#1a79a2')};
  }
  ${breakpoint('mobile', 'tablet')`
    height:30px;
  `}
  ${breakpoint('tablet', 'desktop')`
    height:40px;
  `}
`;
export const StyledDiagnoseIcon = styled(DiagnoseIcon)`
  height: 50px;
  width: 120px;
  path {
    fill: ${props => (props.domain ? 'rgb(0, 81, 78)' : '#1a79a2')};
  }
  ${breakpoint('mobile', 'tablet')`
    height:42px;
  `}
  ${breakpoint('tablet', 'desktop')`
    height:40px;
  `}
`;
export const StyledNABHIcon = styled(NABHIcon)`
  height: 50px;
  width: 120px;
  path {
    fill: ${props => (props.domain ? 'rgb(0, 81, 78)' : '#1a79a2')};
  }
  ${breakpoint('mobile', 'tablet')`
    height:40px;
  `}
  ${breakpoint('tablet', 'desktop')`
    height:40px;
  `}
`;
export const StyledSpecialitiesIcon = styled(SpecialitiesIcon)`
  height: 50px;
  width: 120px;
  path {
    fill: ${props => (props.domain ? 'rgb(0, 81, 78)' : '#1a79a2')};
    stroke: ${props => (props.domain ? 'rgb(0, 81, 78)' : '#1a79a2')};
  }
  ${breakpoint('mobile', 'tablet')`
    height:37px;
  `}
  ${breakpoint('tablet', 'desktop')`
    height:40px;
  `}
`;

export const StyledContentBlock = styled.div`
  ${{ RichTextStyle }}
  /* margin:0rem !important; */
  display: flex;
  flex-direction: column;
  padding: 10px;
  border-radius: 10px;
  justify-content: space-between;
  border  :${props => (props.domain ? '1px solid rgb(226, 232, 234)' : '1px solid #E2E8EA')};
  background:${props => (props.domain ? 'rgb(241, 255, 252)' : '#f8fdff')};
  ${breakpoint('mobile', 'desktop')`
    flex-direction: column;
    width: 93%;
    padding:3%;
  
  `}
    /* margin:0 2%; */
`;

export const StyledHeading = styled.div`
  padding: 15px 0px 20px 0px;
  color:${props => (props.domain ? 'rgb(0, 81, 78)' : '#1a79a2')};
  font-size: 25px;
  font-weight: 700;
  line-height: 1.2;
  ${breakpoint('mobile', 'desktop')`
  padding: 15px 0px 0px 0px;
  `}
`;

export const StyledBookNow = styled.div`
  display: flex;
  padding: 10px;
  width: fit-content;
  align-items: center;
  font-size: 16px;
  border-radius: 10px;
  margin: 10px;
  margin-left: 0px;
  color: ${theme.colors.white};
  & :hover {
    cursor: pointer;
  }
  background-image: ${props => (props.domain
    ? 'linear-gradient(118.6deg, rgb(91, 160, 160) 2%, rgb(68, 137, 137) 30%, rgb(39, 99, 99) 66%, rgb(20, 77, 77) 100%)'
    : 'linear-gradient(118.6deg,#63aecf 0%,#629ece 30.63%,#458fd3 63.31%,#3a78b1 98.02%)')};

  ${breakpoint('mobile', 'desktop')`
    margin:0px;
    margin-top:5px;
    margin-bottom:15px;
    padding:10px;
    font-size:18px;
  `}
  ${breakpoint('tablet', 'tablet')`
    padding:10px;
  `}

  @media(min-width:450px) and (max-width:600px) {
    padding: 2%;
    font-size: 18px;
  }
  @media (min-width: 600px) and (max-width: 736px) {
    padding: 2%;
    font-size: 20px;
  }
`;

export const StyledRichTextContent = styled.div`
  ${RichTextStyle}
  p {
    font-size: 16px !important;
  }
  ${breakpoint('mobile', 'tablet')`
    p{
      font-size:13px !important;
    }
  `}
  ${breakpoint('tablet', 'desktop')`
    p{
      font-size:15px !important;
    }
  `}
`;

export const StyledCoverWrapper = styled.div`
  max-width: 1400px;
  width: 100%;
  ${pb(0)}
  /* ${m(0)} */
  margin: 0 auto;
`;

export const StyledSectionElement = styled.div`
/* flex-basis: 54%; */
width: 55%;
${breakpoint('mobile', 'desktop')`
    width:100%;
`}
`;

export const StyledItemContent = styled.div`
width: 45%;
  ${breakpoint('tablet', 'mobile')`
    width:100%;
   margin: 2rem auto;
   ${pt(4)}
`}

  ${breakpoint('mobile', 'desktop')`
    display:flex;
    justify-content:center;
    width:100%;
    margin:1rem 0rem;
  `}
`;

export const StyledFormWrapper = styled.div`
  ${breakpoint('desktop')`
    position: sticky;
    ${pl(5)}
    top: 100px;
    align-items: flex-start;
  `}
  ${breakpoint('mobile', 'desktop')`
    max-width: ${formWidth};
    align:center;
  `}
`;

export const StyledBannerLeftWrapper = styled.div`
  display: flex;
  flex-direction: row;
  background-color:${props => (props.domain ? 'rgb(241, 255, 252)' : '#eafbff')};
  border-radius: 14px;
  margin: 0.5rem 1.5rem;

  ${breakpoint('mobile', 'desktop')`
    margin:0rem;
    margin-top: 10px;
    flex-direction:column-reverse;
  `}
`;

export const StyledUpperWrapper = styled.div`
  display: flex;
`;
// display: flex;
//   flex-wrap: wrap;
export const StyledHeader = styled.div`
  ${breakpoint('tablet', 'desktop')`
  margin:0% 8%;
`}
`;

export const StyledParaLink = styled.a`
  right: 1rem;
  position: absolute;
  font-size: 32px;
  font-weight: 700;
  line-height: 39px;
  color: ${colors.darkBlue};
  cursor: pointer;

  ${breakpoint('mobile', 'tablet')`
    font-size: 16px;
    line-height: 19px;
  `}

  ${breakpoint('tablet', 'desktop')`
    font-size: 20px;
  `}
`;

export const StyledBoldHeadingText = styled.div`
  font-size: 18px;
  font-weight: bold;
  font-style: italic;
  p {
    white-space: pre-wrap;
  }
`;
export const StyledCover = styled(StyledCoverMaxWidth)`
  ${maxWidthWideStyle}
  max-width: 1200px;
  margin: 0 auto;
`;

export const StyledBody = styled(StyledCoverMaxWidth1)`
  ${mb(0)}
  ${p(0)}
  ${breakpoint('desktop')`
    ${p(0)}
    ${mb(0)}
  `}
  ${breakpoint('mobile', 'desktop')`
    width:100%;
    margin: 1rem 0rem;
  `}
`;

export const StyledExpandedBody = styled.div`
  ${maxWidthWideStyle}

  margin-left: auto;
  margin-right: auto;
`;

export const StyledSection = styled.div`
  ${({ full }) => !full && px(0)};
  color: black;
  box-sizing: border-box;
  padding: 25px 0px;
`;

export const StyledSectionHeadline = styled.h2`
  ${mt(4)};
  ${pb(4)};
  color: #136c9d;
  font-weight: bold;
  text-transform: uppercase;
  font-size: 20px;
  text-align: ${props => (props.leftalign ? 'left' : 'center')};
`;

export const StyledBannerWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  color:${props => (props.domain ? 'rgb(0, 81, 78)' : '#136c9d')};
  ${pl(4)};
  ${pr(3)};
  ${breakpoint('mobile', 'desktop')`
    padding-left:15px;
    flex-wrap:wrap;
  `}
`;

export const MainContactFormWrapper = styled(StyledSection)`
  display: ${({ mobileVisible }) => (mobileVisible ? 'block' : 'none')};
  ${mt(8)};

  ${breakpoint('desktop')`
    max-width: ${formWidth};
    display: ${({ desktopVisible }) => (desktopVisible ? 'block' : 'none')};
  `}

  // If IE
  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    flex: 1;
  }
`;

export const StyledAboutText = styled.p`
  ${fontCopyDefault};
  color: ${theme.colors.darkBlue};
`;

export const MainContactForm = styled.div`
  ${my(4)};
  ${px(3)};
  ${py(5)};
  ${mx(-3)};
  box-sizing: border-box;
  min-height: 500px;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  ${props => props.created && 'height: 50%;'};
  display: ${({ mobileVisible }) => (mobileVisible ? 'block' : 'none')};

  ${breakpoint('mobile', 'desktop')`
    ${gradients.linearTurquoiseBlueTTB}
  `};

  ${breakpoint('desktop')`
    ${p(4.5)}
    ${pr(4.5)}
    ${my(0)}
    ${mx(0)}
    
    padding-left: 40px;

    margin-left: 110px;
    width: calc(100% - 110px);

    height: auto;
    border-radius: 3%;
    color: #fff;
    ${gradients.linearFadedBlueSoftBlueLTR};
    display: ${({ desktopVisible }) => (desktopVisible ? 'block' : 'none')};
  `}
`;

export const StyledHeadlineText = styled.h1`
  line-height: 1.2;
  margin-top: 10px;
  margin-bottom: 10px;
  color:${props => (props.domain ? 'rgb(0, 81, 78)' : '#136c9d')};
  font-size: 30px;
  font-weight: bold;
  ${pr(3)};

  ${breakpoint('mobile', 'desktop')`
    font-size:24px;
    ${pr(0)};
  `};
`;

export const StyledFormCover = styled.div`
  background-color: ${colors.white};
  ${borderRadius.medium};
  ${shadows.medium};
  ${pb(3.5)};
  ${px(3.5)};
  position: relative;
  flex: 1;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  ${breakpoint('desktop')`
    ${pb(0)}
    ${px(0)}
    background-color: transparent;
    box-shadow: none;
  `}
`;

export const StyledMapContainer = styled.div`
  width: 100%;
  height: 600px;
`;

export const StyledElementGridUnit = styled(Grid.Unit)``;

export const StyledHeaderImageWrapper = styled.div`
  flex: 0 0 60%;
  border-radius: 2%;
  display: flex;
  ${breakpoint('mobile', 'tablet')`
     height: fit-content;
     width:100%;
     ${pb(3)};
  `};
`;

export const StyledHeaderImage = styled.img.attrs({ loading: 'lazy' })`
  border-radius: 14px 14px 6px 6px;
  width: 100%;
  height: 370px;
  object-fit: cover;

  ${breakpoint('mobile', 'desktop')`
   height:250px;
  `};
`;

export const StyledHeaderVideo = styled(Video)`
  width: 100%;
  height: auto;

  ${breakpoint('desktop')`
    height: 100%;

    video {
      height: 100%;
      object-fit: cover;
      object-position: center;
      font-family: 'object-fit: cover; object-position: center;';
    }

    transform-origin: bottom right;
    transform: skewX(-8deg);
  `}
`;

export const StyledOverviewWrapper = styled.div`
  ${sectionSpacing}

  ${breakpoint('mobile', 'tablet')`
   max-width:50%;
    ${px(3)};
    `}
`;

export const StyledSummaryHeaderWrapper = styled(Grid)`
justify-content: center;
  ${breakpoint('mobile', 'desktop')`
    display:flex;
    flex-direction:column-reverse;
    align:center;
    margin:0% 3%;
    `}
`;

export const StyledOverviewData = styled.div`
  width: 90%;
  ${breakpoint('mobile', 'desktop')`
    height: 100%;
    width: 100%;
  `}
`;
export const StyledHighlightsWrapper = styled.div`
  width: 50%;
`;

export const StyledHighlightsData = styled.div``;

export const StyledShowMore = styled.span`
  position: relative;
  float: right;
  color: #729cc2;
  font-size: 20px;
  font-weight: bold;
  cursor: pointer;
  ${m(4)};
`;

export const StyledBulletListWrapper = styled.div`
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
  ${props =>
    (props.showMore
      ? `
  max-height: unset;
  overflow: hidden;
`
      : `
  max-height: 404px;
  overflow: hidden;

`)}
`;
